import styled from "styled-components"
import constants from "utils/constants"

export default function Banner({ filename }) {
	return (
		<ComponentWrapper>
			{filename && (
				<BannerImg src={`${constants.imagePath}/motibell/banner_img/${filename}`} />
			)}
		</ComponentWrapper>
	)
}
const ComponentWrapper = styled.div``
const BannerImg = styled.img``
